import PropTypes from 'prop-types';
import React from 'react';

// this component is just a placeholder for whatever content you would normally have underneath the search bar
export default function PlaceholderGrid({columns = 3, boxes = 12}) {
  return (
    <ul
      style={{
        marginTop: '1 rem',
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridGap: '1rem',
        listStyle: 'none',
        padding: '0'
      }}
    >
      {Array.from({length: boxes}, (_, i) => (
        <li
          key={i}
          style={{
            backgroundColor: 'rgba(128, 126, 163, 0.08)',
            borderRadius: '5px',
            height: '100%',
            minHeight: '202px',
            width: '100%'
          }}
        />
      ))}
    </ul>
  );
}

PlaceholderGrid.propTypes = {
  columns: PropTypes.number,
  boxes: PropTypes.number
};
